/* eslint-disable react-hooks/rules-of-hooks */
/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/
/* eslint-disable no-unused-expressions */

import React, { useState, useEffect, useContext, useRef } from 'react';

import Layout from 'components/Layout';
import BrokingSummary from 'components/BrokingSummary';
import Button, { ButtonContainer } from 'components/Button';
import ContentCard from 'components/ContentCard';
import FileModal from 'components/FileModal';
import { FitinsurAPI, MessageCenter } from 'utils';
import { useHistory } from 'react-router-dom';
import { GlobalAuthContext, GlobalLoaderContext } from 'store/context';
import { Scrollbox, TextArea, ButtonContent } from './styles';
import Loader from 'components/Loader/index';
import Colors from 'constants/Colors';
import { LostCancelButton, TextEditorBox } from 'components/index';
import StepNavigation from 'components/StepNavigation/index';
import RenderButtons from 'components/RenderButtons';
import { Field, Formik } from 'formik';
import InputField from 'components/Form/InputField';
import HasPermission from 'components/HasPermission/index';
import { useHeaderNbi, useFileNbiEmail } from 'services/QuoteService';
import { useOperationInfo } from 'services/OperationService';

export default function NbiRequest(props) {
  const formikRef = useRef(null);
  const [summary, setSummary] = useState({});
  const [file, setFile] = useState();
  const [historymsg, setHistorymsg] = useState([]);
  const [nbiMessage, setNbiMessage] = useState("");
  const [initialNbiMessage, setInitialNbiMessage] = useState("");
  const [initial, setInitial] = useState({
    subject: "",
  })

  const loading = useContext(GlobalLoaderContext);
  const authContext = useContext(GlobalAuthContext);
  const history = useHistory();

  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();
  const [isBound, setIsBound] = useState('');
  const isClient = authContext.enumProfile === 1 ? true : false;

  const goToLoginPage = () => {
    history.push('/login');
  };

  const {
    data: useHeaderNbiData,
    loading: useHeaderNbiLoading,
    error: useHeaderNbiError,
    status: useHeaderNbiStatus,
    request: useHeaderNbiRequest,
  } = useHeaderNbi();

  const {
    data: useOperationInfoData,
    loading: useOperationInfoLoading,
    error: useOperationInfoError,
    status: useOperationInfoStatus,
    request: useOperationInfoRequest,
  } = useOperationInfo(props.match.params.idOperation);

  const {
    data: useFileNbiEmailData,
    loading: useFileNbiEmailLoading,
    error: useFileNbiEmailError,
    status: useFileNbiEmailStatus,
    request: useFileNbiEmailRequest,
  } = useFileNbiEmail();

  useEffect(() => {
    if (useHeaderNbiLoading || useOperationInfoLoading || useFileNbiEmailLoading) {
      loading.start();
    } else {
      loading.stop();
    }
  }, [useHeaderNbiLoading, useOperationInfoLoading, useFileNbiEmailLoading]);

  function handleFileNbiRequestEmail() {
    useFileNbiEmailRequest({idOperation: props.match.params.idOperation, idTemplate: 186}, null).then(({data}) => {
        setFile(data);
      })
      .catch((error) => {
        mc.error(`There was an error while fetching your data: ${handleFileNbiRequestEmail.name}\n` + error);
        console.error('fitPostFiles - Error:', error);
      });
  };


  function handleFile() {
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestFileList(props.match.params.idOperation)
      .then(response => response.text())
      .then((data) => {})
      .catch((error) => {
        mc.error(`There was an error while fetching your data: ${handleFile.name}\n` + error);
        console.error('fitPostFiles - Error:', error);
      });
  };

  function handleHistoryMessage() {
    let tempmessage = "";
    if (historymsg?.length >= 1) {
      historymsg.map(
        (message, index) => {
          const tempMsg = `[${index + 1}] - Name: ${message.userFullName}, Date: ${message.approvalDate}
            ${message.approvalComments}
      
              `;
          tempmessage = (tempmessage + tempMsg);
        }
      )
      return tempmessage;
    }

  };

  function handleSummary() {
    useHeaderNbiRequest({idOperation: props.match.params.idOperation}, null).then(({data}) => {
      setSummary({
          typeOfCover: data.ret_value.typeOfCover,
          client: data.ret_value.client,
          obligorCoding: data.ret_value.obligorCoding,
          responseBy: data.ret_value.responseBy,
          internalContact: data.ret_value.internalContact,
          broker: data.ret_value.broker,
          dealCode: data.ret_value.deal,
          nmFacility: data.ret_value.nmFacility,
          nmObligor: data.ret_value.nmObligor,
          projectName: data.ret_value.projectName,
          idOperation: props.match.params.idOperation,
        });
        setInitialNbiMessage(data.ret_value.nbiSubjectMessage);
        setHistorymsg(data.ret_value.historical);
        formikRef.current?.setFieldValue("subject", data.ret_value.nbiSubject);
      })
      .catch((error) => {
        mc.error(`There was an error while fetching your data: ${handleSummary.name}\n` + error);
        console.error('fitPostSummary - Error:', error);
      });
  };

  function handleBack() {
    history.goBack();
  }

  async function handleSendAproval() {
    loading.start();
    fitinsur.setAuthToken(authContext.token);

    if (nbiMessage === "") {
      loading.stop();
      return mc.error("Please, insert NBI request message");
    }
    fitinsur.requestAproveNbiForm(props.match.params.idOperation, nbiMessage, formikRef.current.values.subject).then(x => x.json()).then((resp) => {
      loading.stop();
      if (resp.ret_code === 200) {
        history.push(`/broking/approval-nbi/${props.match.params.idOperation}`, { idOperation: props.match?.params?.idOperation || null, idProduct: props.location?.state?.idProduct || null });
      } else {
        mc.error(resp.ret_msg_details);
      }
    }).catch((error) => {
      mc.error(`There was an error while fetching your data: ${handleSendAproval.name}\n` + error);
      console.error('fitPostAproveNBI - Error:', error);
    });


  };

  useEffect(() => {
    fitinsur.setAuthToken(authContext.token);
  
    handleFile();
    handleSummary();
    handleOperationInfo(); 
    handleFileNbiRequestEmail();

  }, [])

  const handleOperationInfo = () => {
    useOperationInfoRequest().then(({data}) => {
      setIsBound(data.isBound || false)
      })
  }
  

  return (
    <Layout idOperation={props.match?.params?.idOperation} title={summary.projectName ? summary.projectName : summary.nmObligor ? summary.nmObligor : "Broking name"} subtitle={summary.dealCode ? summary.dealCode : "Deal Code"}>
        <StepNavigation stage={2} idOperation={props.match?.params?.idOperation} /> 
      <Scrollbox>
        <BrokingSummary data={summary ? summary : ''} />
        <ContentCard title="GENERATE NBI REQUEST" icon info={{ idOperation: props.match?.params?.idOperation || null, idProduct: props.location?.state?.idProduct || null }}>
          <Formik
            innerRef={formikRef}
            initialValues={initial}
            enableReinitialize={true}
          >
            {({ setFieldValue, values }) => (
              <Field
                name="subject"
                readOnly={isBound}
                label="NBI Request e-mail Subject Line"
                component={InputField}
                value={values.subject}
                onChange={(e) => setFieldValue("subject", e)}
                disabled
              />
            )}
          </Formik>
          <TextEditorBox
            label="NBI Request Message - (External)"
            onChange={(value) => setNbiMessage(value)}
            initialValue={initialNbiMessage}
            disabled={isBound}
          />

          <FileModal idOperation={props?.match?.params?.idOperation} file={file} actions={false}/>
          <TextArea
            readOnly
            value={handleHistoryMessage()}
          />
            <ButtonContainer>
              <Button forth onClick={() => handleBack()}>&lt; Back</Button>
              <HasPermission permission={!isBound}>
              <RenderButtons idOperation={props.match?.params?.idOperation}>
                <ButtonContent>
                  <div style={{ marginTop: "5px" }}>
                    <LostCancelButton idOperation={props.match?.params?.idOperation} />
                  </div>
                  {!isClient && (
                    <Button primary onClick={() => handleSendAproval()} style={{ marginLeft: "10px", marginTop: "5px" }}>
                      SEND APPROVAL
                    </Button>
                  )}
                </ButtonContent>
              </RenderButtons>
              </HasPermission>
            </ButtonContainer>
          {loading.active && <Loader backdropColor={Colors.WHITE} fullScreen />}
        </ContentCard>
      </Scrollbox>
    </Layout >
  )
}
